import { render, staticRenderFns } from "./upDownManage.vue?vue&type=template&id=1e006282&scoped=true"
import script from "./upDownManage.vue?vue&type=script&lang=js"
export * from "./upDownManage.vue?vue&type=script&lang=js"
import style0 from "./upDownManage.vue?vue&type=style&index=0&id=1e006282&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e006282",
  null
  
)

export default component.exports